import styled from 'styled-components';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { bubbleBaseStyles, textBaseStyles } from './WelcomeMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const HiddenBubble = styled.div.withConfig({
  displayName: "HiddenWelcomeMessage__HiddenBubble",
  componentId: "itm8xw-0"
})(["", " height:0;min-height:0;visibility:hidden;overflow:hidden;"], bubbleBaseStyles);
const HiddenText = styled.p.withConfig({
  displayName: "HiddenWelcomeMessage__HiddenText",
  componentId: "itm8xw-1"
})(["", ""], textBaseStyles);
export const HiddenWelcomeMessage = ({
  initialMessage
}) => {
  if (!initialMessage) {
    return null;
  }
  return /*#__PURE__*/_jsx(HiddenBubble, {
    children: /*#__PURE__*/_jsx(HiddenText, {
      dangerouslySetInnerHTML: {
        __html: formatHtml(initialMessage)
      }
    })
  });
};
HiddenWelcomeMessage.displayName = 'HiddenWelcomeMessage';
export default HiddenWelcomeMessage;